export default __webpack_public_path__ + "static/media/sub-topic-model-02.5c222429.glb";